import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { ELanguages } from 'src/shared/enum';

const LanguageSwitchLink = ({ locale, styles, ...rest }: any) => {
  const { i18n } = useTranslation(['main']);
  const navigate = useNavigate();
  const currentLocale = i18n.language;

  return (
    <>
      <button
        onClick={() => {
          if (i18n.language !== locale) {
            i18n.changeLanguage(locale);
            // navigate('/order')
          }
        }}
        className={`px-1 py-1 ${
          locale === currentLocale &&
          `${styles || 'bg-primary text-white'} ${
            locale === ELanguages.EN ? 'rounded-l-[10px]' : 'rounded-r-[10px]'
          }`
        }`}>
        {locale}
      </button>
    </>
  );
};

export default LanguageSwitchLink;
